import {
    useEffect,
    useRef
} from 'react';

export default function useTrackingId(trackingId) {
    const trackingRef = useRef();

    useEffect(() => {
        if (trackingRef.current && trackingId) {
            trackingRef.current.setAttribute('data-tracking-id', trackingId);
        }
    }, [trackingRef, trackingId]);

    return trackingRef;
}
